/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { DeleteOneBaseAodRulesControllerAodRuleMutationResponse, DeleteOneBaseAodRulesControllerAodRulePathParams } from "../models/DeleteOneBaseAodRulesControllerAodRule";

export function getDeleteOneBaseAodRulesControllerAodRuleUrl(id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"]) {
  const res = { method: 'DELETE', url: `/aod-rules/${id}` as const }
  return res
}

/**
 * @summary Delete a single AodRule
 * {@link /aod-rules/:id}
 */
export async function deleteOneBaseAodRulesControllerAodRule(id: DeleteOneBaseAodRulesControllerAodRulePathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDeleteOneBaseAodRulesControllerAodRuleUrl(id).url.toString(), ... requestConfig })
  return res.data
}